// extracted by mini-css-extract-plugin
export default {"item":"CategoryItem_item__ViKob","active":"CategoryItem_active__4j56R"};